import { useEffect, useState } from 'react';
import { useMeeting } from '../meeting/meetingProviderContextDef';
import { eventEmitter, events } from '../utils';

/**
 *
 * @returns {{
 *  startWhiteboard: () => Promise<void>,
 *  stopWhiteboard: () => Promise<void>,
 *  whiteboardUrl: string | null
 * }}
 */

const useWhiteboard = () => {
  const { meeting, isMeetingJoined } = useMeeting();
  const [whiteboardUrl, setWhiteboardUrl] = useState(null);

  useEffect(() => {
    if (!isMeetingJoined || !meeting) return;

    const handleWhiteboardStarted = data => {
      if (data?.url) {
        setWhiteboardUrl(data.url);
      }
    };

    const handleWhiteboardStopped = () => setWhiteboardUrl(null);

    eventEmitter.on(events['whiteboard-started'], handleWhiteboardStarted);
    eventEmitter.on(events['whiteboard-stopped'], handleWhiteboardStopped);

    return () => {
      eventEmitter.off(events['whiteboard-started'], handleWhiteboardStarted);
      eventEmitter.off(events['whiteboard-stopped'], handleWhiteboardStopped);
    };
  }, [meeting, isMeetingJoined]);

  const startWhiteboard = async () => {
    if (!isMeetingJoined || !meeting) {
      return;
    }

    try {
      await meeting.startWhiteboard();
    } catch (error) {
      console.error('Error starting whiteboard:', error);
    }
  };

  const stopWhiteboard = async () => {
    if (!isMeetingJoined || !meeting) {
      return;
    }

    try {
      await meeting.stopWhiteboard();
    } catch (error) {
      console.error('Error stopping whiteboard:', error);
    }
  };

  return {
    whiteboardUrl,
    startWhiteboard,
    stopWhiteboard
  };
};

export default useWhiteboard;
